<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="data.category_name"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  ></kt-portlet-header>
  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CATEGORY.TABLE.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let teamMember">{{ teamMember.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let teamMember" class="profile-pic justify-content-center">
            <kt-user-photo
              [fromTeamMemList]="true"
              [create]="'false'"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="teamMember"
            ></kt-user-photo>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Team Member</mat-header-cell>
          <mat-cell *matCellDef="let teamMember" class="flex-column align-items-start">
            <span>{{ teamMember | getUserFullName }}</span>
            <a href="mailto:{{ teamMember.email }}">{{ teamMember.email }}</a>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer class="d-flex justify-content-end">
    <button
      mat-raised-button
      class="btn btn-light"
      (click)="$event.stopPropagation(); dialogRef.close()"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
  </kt-portlet-footer>
</kt-portlet>
